(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4637],{

/***/ 94033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment productListInformation on Product {\n    _id\n    name\n    description\n    nicknames\n    altImg\n    titleImg\n    images {\n      _id\n      url\n      # colors {\n      #   blurhash4x4\n      # }\n      imageSmall: resizedURL(width: 320, height: 320, format: $format)\n    }\n    availabilityAt(menuId: $menuId) {\n      basePrice\n      finalPrice\n      pastPrices\n      hasDiscount\n      available\n      notAvailableMessage\n    }\n    isOutOfStock\n    menu(menuId: $menuId) {\n      _id\n      channels\n    }\n    modifiers {\n      _id\n      description\n      isImageModifier\n      max\n      min\n      name\n      optional\n      options {\n        _id\n        availabilityAt(menuId: $menuId) {\n          available\n          menuId\n          price\n        }\n        max\n        name\n      }\n    }\n    informativeStamps\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ __webpack_exports__["Z"] = ((0,graphql_tag__WEBPACK_IMPORTED_MODULE_0__["default"])(_templateObject()));


/***/ }),

/***/ 50046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductWithRequiredModifiers; }
/* harmony export */ });
function ProductWithRequiredModifiers(product) {
    if (!product.modifiers) return null;
    return !!product.modifiers.find(function(modifier) {
        return !modifier.optional;
    });
};


/***/ }),

/***/ 13336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SelectPriceForProduct; }
/* harmony export */ });
function SelectPriceForProduct(product) {
    var availabilityAt = product.availabilityAt;
    if (!availabilityAt) return null;
    var hasDiscount = availabilityAt.hasDiscount, finalPrice = availabilityAt.finalPrice, basePrice = availabilityAt.basePrice, available = availabilityAt.available, notAvailableMessage = availabilityAt.notAvailableMessage;
    if (!available) return {
        type: "notAvailable",
        message: notAvailableMessage
    };
    if (hasDiscount) return {
        type: "discount",
        price: finalPrice,
        oldPrice: basePrice
    };
    if (!finalPrice) return null;
    return {
        type: "normal",
        price: finalPrice
    };
};


/***/ }),

/***/ 76722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageComponent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5434);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56036);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12284);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68176);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);



// import useBlurhash from '@hooks/useBlurhash'



function ImageComponent(props) {
    var product = props.product;
    var image = product.images ? product.images[0] : null;
    // const blurhash = useBlurhash(image?.colors?.blurhash4x4, 166, 166)
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("website", {
        keyPrefix: "order.products.productsContent.category.product.image"
    }).t;
    if (!product.images || !product.images.length) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().noImage),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().noImageText),
                children: t("labelNoImage")
            })
        });
    }
    var productImg = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            src: image.imageSmall,
            alt: product.altImg || product.name,
            title: product.titleImg || product.name,
            layout: "fill",
            objectFit: "cover"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().image), " ").concat((_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default()["img-fit-container"])),
        children: [
            productImg(),
            product.images.length > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().hasMultipleImages),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_5__/* .MdPhotoLibrary */ .C0e, {
                    size: 18
                })
            })
        ]
    });
};


/***/ }),

/***/ 14637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Category_Product; }
});

// UNUSED EXPORTS: Product

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/data/fragments/products/productListInformation.ts
var productListInformation = __webpack_require__(94033);
;// CONCATENATED MODULE: ./src/helpers/misc/queryObjectToString.ts
var hiddenKeys = [
    "hostname",
    "mobileOrDesktop"
];
function queryObjectToString(query) {
    return Object.keys(query).filter(function(key) {
        return !hiddenKeys.includes(key);
    }).map(function(key) {
        return "".concat(key, "=").concat(query[key]);
    }).join("&");
};

// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/components/InformativeStamps/index.tsx + 1 modules
var InformativeStamps = __webpack_require__(79989);
// EXTERNAL MODULE: ./src/i18n/formatNumber/Component.tsx
var Component = __webpack_require__(18085);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 37 modules
var esm = __webpack_require__(12284);
// EXTERNAL MODULE: ./node_modules/slugify/slugify.js
var slugify = __webpack_require__(31304);
var slugify_default = /*#__PURE__*/__webpack_require__.n(slugify);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/components/Button/index.tsx
var Button = __webpack_require__(40076);
// EXTERNAL MODULE: ./src/helpers/misc/productWithRequiredModifiers.ts
var productWithRequiredModifiers = __webpack_require__(50046);
// EXTERNAL MODULE: ./src/helpers/misc/selectPriceForProduct.ts
var selectPriceForProduct = __webpack_require__(13336);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/SelectProduct/Inner/useAdd/index.tsx + 4 modules
var useAdd = __webpack_require__(16337);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/styles.module.css
var styles_module = __webpack_require__(43908);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Cards/RowProduct/index.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}














function RowProduct(props) {
    var ref;
    var router = (0,next_router.useRouter)();
    var image = props.image, product = props.product, description = props.description, onClick = props.onClick, menuId = props.menuId, _fastAddToCart = props.fastAddToCart, fastAddToCart = _fastAddToCart === void 0 ? false : _fastAddToCart, hidePrice = props.hidePrice, reverse = props.reverse, href = props.href;
    var isOutOfStock = product.isOutOfStock, name = product.name, images = product.images;
    var add = (0,useAdd/* default */.Z)();
    var requiredModifiers = (0,productWithRequiredModifiers/* default */.Z)(product);
    var pricing = (0,selectPriceForProduct/* default */.Z)(product);
    var t = (0,esm/* useTranslation */.$G)("website", {
        keyPrefix: "order.products.productsContent.category.product.cards.rowProduct"
    }).t;
    var buttonKeyLabel = isOutOfStock ? "labelOutOfStock" : "labelAddProduct";
    var informativeStampsList = product === null || product === void 0 ? void 0 : (ref = product.informativeStamps) === null || ref === void 0 ? void 0 : ref.slice(0, 3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((styles_module_default()).container, " ").concat(isOutOfStock ? (styles_module_default()).containerOutOfStock : null, " ").concat(reverse ? (styles_module_default()).reverse : null),
        children: [
            images && images.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (styles_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: href,
                    scroll: false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: onClick,
                        children: image
                    })
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).contentContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).content,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: href,
                            scroll: false,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                onClick: onClick,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).name,
                                        children: name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStamps/* default */.Z, {
                                        stamps: informativeStampsList,
                                        iconOnly: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (styles_module_default()).description,
                                        children: description
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).priceContainer,
                        children: [
                            pricing && !hidePrice ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: href,
                                    scroll: false,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (styles_module_default()).price,
                                        onClick: onClick,
                                        children: [
                                            pricing.type === "normal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                                value: pricing.price
                                            }),
                                            pricing.type === "discount" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                                        value: pricing.price
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                                                            value: pricing.oldPrice
                                                        })
                                                    })
                                                ]
                                            }),
                                            pricing.type === "notAvailable" && pricing.message
                                        ]
                                    })
                                })
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                primary: true,
                                onClick: _asyncToGenerator(runtime_default().mark(function _callee() {
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!hidePrice) {
                                                    _ctx.next = 3;
                                                    break;
                                                }
                                                (0,fireEvent["default"])("hiddenPriceProductOpened", product);
                                                return _ctx.abrupt("return", null);
                                            case 3:
                                                if (!isOutOfStock) {
                                                    _ctx.next = 5;
                                                    break;
                                                }
                                                return _ctx.abrupt("return", null);
                                            case 5:
                                                if (!(requiredModifiers || !fastAddToCart)) {
                                                    _ctx.next = 9;
                                                    break;
                                                }
                                                {
                                                    onClick();
                                                    router.push(href, href, {
                                                        scroll: false
                                                    });
                                                }
                                                _ctx.next = 11;
                                                break;
                                            case 9:
                                                _ctx.next = 11;
                                                return add(_objectSpread({}, props, {
                                                    close: function() {
                                                    // avoid error on add to cart
                                                    },
                                                    menuId: menuId
                                                }), {
                                                    amount: 1,
                                                    modifiers: [],
                                                    comment: ""
                                                }, product, {
                                                    missingModifier: false
                                                });
                                            case 11:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                })),
                                disabled: isOutOfStock,
                                children: t(buttonKeyLabel)
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/Image/index.tsx
var Image = __webpack_require__(76722);
// EXTERNAL MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/styles.module.css
var Product_styles_module = __webpack_require__(68176);
var Product_styles_module_default = /*#__PURE__*/__webpack_require__.n(Product_styles_module);
;// CONCATENATED MODULE: ./src/page-components/Order/Products/ProductsContent/Category/Product/index.tsx
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/* eslint-disable @typescript-eslint/ban-types */ 













var _Component;
var Product = /*#__PURE__*/ function(_superClass) {
    "use strict";
    _inherits(Product, _superClass);
    var _super = _createSuper(Product);
    function Product() {
        _classCallCheck(this, Product);
        var _this;
        _this = _super.apply(this, arguments);
        _this.state = {};
        _this.onClick = function() {
            var _props = _this.props, product = _props.product, hidePrice = _props.hidePrice, router = _props.router;
            if (hidePrice) {
                (0,fireEvent["default"])("hiddenPriceProductOpened", product);
                return;
            }
            (0,posthog.sendPosthogData)(posthog.EVENTS.clicked.product);
            if (_this.props.select) {
                _this.props.select();
                return;
            }
        };
        return _this;
    }
    var _proto = Product.prototype;
    _proto.renderPriceWithDiscounts = function renderPriceWithDiscounts() {
        if (this.props.hidePrice) return null;
        var _availabilityAt = this.props.product.availabilityAt, finalPrice = _availabilityAt.finalPrice, basePrice = _availabilityAt.basePrice;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Product_styles_module_default()).pastPrice,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: basePrice
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Product_styles_module_default()).price,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                        value: finalPrice
                    })
                })
            ]
        });
    };
    _proto.renderPrice = function renderPrice() {
        var availabilityAt = this.props.product.availabilityAt;
        if (!availabilityAt) return;
        var hasDiscount = availabilityAt.hasDiscount, finalPrice = availabilityAt.finalPrice, available = availabilityAt.available, notAvailableMessage = availabilityAt.notAvailableMessage;
        if (!available) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Product_styles_module_default()).notAvailable,
            children: notAvailableMessage
        });
        if (!available) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Product_styles_module_default()).notAvailable,
            children: this.props.t("fields.notAvailable", {
                ns: "generic"
            })
        });
        if (hasDiscount) return this.renderPriceWithDiscounts();
        if (!finalPrice) return null;
        if (this.props.hidePrice) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Product_styles_module_default()).price,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Component/* default */.Z, {
                value: finalPrice
            })
        });
    };
    _proto.renderOutOfStock = function renderOutOfStock() {
        var isOutOfStock = this.props.product.isOutOfStock;
        if (!isOutOfStock) return;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Product_styles_module_default()).outOfStock,
            children: this.props.t("fields.outOfStock", {
                ns: "generic"
            })
        });
    };
    _proto.render = function render() {
        var ref;
        var _props = this.props, product = _props.product, productCardDesign = _props.productCardDesign, hidePrice = _props.hidePrice, menuId = _props.menuId, router = _props.router;
        var description = product.description ? product.description.split("\n\n")[0] : "";
        var className = [
            this.props.productsLayout === "compact" ? (Product_styles_module_default()).compact : (Product_styles_module_default()).container
        ];
        if (product.isOutOfStock) {
            className.push((Product_styles_module_default()).isOutOfStock);
        }
        var query = queryObjectToString(router.query);
        var href = this.props.skipRedirection ? "#" : "/pedir/".concat(product._id, "/").concat(slugify_default()(product.name, {
            lower: true,
            strict: true
        })).concat(query ? "?".concat(query) : "");
        var informativeStampsList = product === null || product === void 0 ? void 0 : (ref = product.informativeStamps) === null || ref === void 0 ? void 0 : ref.slice(0, 3);
        var info = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Product_styles_module_default()).info,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Product_styles_module_default()).nameAndDescription,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Product_styles_module_default()).name,
                        children: product.name
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InformativeStamps/* default */.Z, {
                            stamps: informativeStampsList,
                            iconOnly: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Product_styles_module_default()).nameAndDescription,
                            children: this.props.productsLayout === "compact" ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Product_styles_module_default()).description,
                                        children: description
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Product_styles_module_default()).space
                }),
                this.renderPrice()
            ]
        });
        var image = /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            product: product
        });
        var isRow = [
            "row",
            "row-inverse",
            "row-inverse-fast",
            "row-fast",
            "row-inverse-fast"
        ].includes(productCardDesign);
        if (isRow) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RowProduct, {
                image: image,
                onClick: this.onClick,
                href: href,
                product: product,
                description: description,
                menuId: menuId,
                reverse: [
                    "row-inverse",
                    "row-inverse-fast"
                ].includes(productCardDesign),
                fastAddToCart: [
                    "row-fast",
                    "row-inverse-fast"
                ].includes(productCardDesign),
                hidePrice: hidePrice
            });
        }
        return this.props.productsLayout === "compact" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: className.join(" "),
                onClick: this.onClick,
                children: [
                    this.renderOutOfStock(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Product_styles_module_default()).img,
                        children: image
                    }),
                    info
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: href,
            scroll: false,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                className: className.join(" "),
                onClick: this.onClick,
                children: [
                    this.renderOutOfStock(),
                    info,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Product_styles_module_default()).img,
                        children: image
                    })
                ]
            })
        });
    };
    return Product;
}(_Component = react.Component);
Product.fragment = productListInformation/* default */.Z;
/* harmony default export */ var Category_Product = ((0,esm/* withTranslation */.Zh)()((0,next_router.withRouter)(Product)));


/***/ }),

/***/ 43908:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"kFAM9r3iQIG0byfT-0DRZ","containerOutOfStock":"_2hcu182p6ge0Ha_zWShSpI","contentContainer":"_178a98bcvBST7K_atUmI91","priceContainer":"_26aJkBHQbAhuvPTrmY-uBl","name":"_160B6gJP3LdIZUn0nc7sQK","description":"_7VMOZBkB065tRJNiM2wV","price":"_1u1utewmgUI9TW1dUfJP2m","callToAction":"_3jqIM86WHEywDUKRiZ5eOn","isOutOfStock":"_2poKx8sEXiLjr0583tkSaG","image":"_2_Q-vJD5-jRaD3i902Eoyl","reverse":"LXQDjkS_dqmYkoosRPgdQ"};

/***/ }),

/***/ 68176:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_22r-bWq7SpQfhu-O7I0ecS buttonShadow menuProductItem textColor","compact":"_2YFsL04WhRxFGT_7VA6bKP buttonShadowHover compactMenuProductItem textColor","isOutOfStock":"CAboaQmRewA78h4-Z4y0_","info":"_3TOwV3RZUG4Ujx57ozcCHZ lighterBackgroundColor","outOfStock":"_5Gc5vjC_XjaLiwIP3_2Il","nameAndDescription":"_2Wn_Ubr02VMh4x3GDzmf1V","name":"_3tOb1kUYtBNfge7JfPDU_D productName","description":"_3B6c_WpWHEkHzgTsj5biDu productDescription descriptionTextColor","space":"vnnpMijtMXu9fU1y3lcEA","image":"_3yULoLW9gpjndljUfLfWLN","noImage":"_1nCMv7Afx2Xj5MC16tl54I","noImageText":"_2pHRf_Y-N8tKQL191aSJKr","hasMultipleImages":"_1on_s_PLo5gXsNMKnepTuM","pastPrice":"_2TqV8qNT9cykzAlTiYQzpR","price":"_3cwJgygKLOPOt2029qoP1N productPrice","notAvailable":"_1auhVO81MuL2pF5rLj2JSv","img-fit-container":"NmGramNcnIM1VmiTq5UPX","img":"_2uBcoliwtdVtvoPWbz7_J-","shine":"_1o_fRI-nt5oPuV0oLoa5zf"};

/***/ })

}]);